import React, { useState, useEffect } from "react";
import classes from "../../controls.module.scss";
import  eventClasses from "./preferencegroups.module.scss"
import { Box, Grid, Button, IconButton } from '@mui/material';
import { Icon } from '@genesis/ui-kit';
import { FormControl, FormControlLabel,InputLabel,MenuItem,Select,TextField,RadioGroup } from '@mui/material';
import { Checkbox } from '@genesis/ui-kit';
import { useSelector } from "react-redux";
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import Cookie from "js-cookie";
import { Dialog, useToggle, Radio } from '@genesis/ui-kit';
import axios from "axios";
import {constants} from "../../../../Shared/Url/Constants";
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import bloomiesReceiptIcon from "../../../../Resources/bloomiesrcpt.png";
import { toUpperCaseString } from "../../../../Shared/Utill/Utills";

const DailyShiftHours = (props) => {
   /* let eventHours =  [{"seqNbr": 1,"ctlName": "eventday01_hours","value1": "20:30","value2": "05:30"},
     {"seqNbr": 2,"ctlName": "eventday02_hours","value1": "21:00","value2": "06:30"}
    ] */
    //let eventHours = props.eventHours

    console.log("evnet hours",props.eventHours) 

    const personDetails = useSelector((state) => state.person.personData);
    const urlDetails = useSelector((state) => state.url.urlData);
    const colleagueTKN = Cookie.get('X_TKN');
    const dialog = useToggle();
    const [isAlertOpen, setAlertOpen] = React.useState({});
    const [rowCount,updateRowCount] = React.useState(props.eventHours.length || 1)
    const [startTime,setStartTime] = React.useState({})
    const [endTime,setEndTime] = React.useState({})
    const [eventHoursList,setEventHoursList] = React.useState([])
    const [readOnlyView,setReadyOnly] = React.useState(true);
    const [haveRemoved,setHaveRemoved] = React.useState(true);
    const [haveAdded,setHaveAdded] = React.useState(true);
    
    const checkBoxOptionsTwo = ["No","Yes","No Change"]
    let tempStart = {}
    let tempEnd = {}
    let length = props.eventHours.length || 1
    for (let i =0; i< length;i++){
       tempStart = { ...tempStart, [i + 1]: props.eventHours.length > 0 ? props.eventHours[i].value1 : null}
       tempEnd = { ...tempEnd, [`end-${i + 1}`]: props.eventHours.length > 0 ? props.eventHours[i].value2 : null }
    }
    

    useEffect(() => {
        props.updateDailyShift(tempStart,tempEnd)
        setStartTime(tempStart)
        setEndTime(tempEnd); 
        
    },[]); 

    useEffect(() => {
        
        if(props.flag === "A"){
            updateRowCount(1)
            setEventHoursList([])

            let tempStart = {}
            let tempEnd = {}
           
            for (let i =0; i< 1;i++){
            tempStart = { [i + 1]:  ""}
            tempEnd = { [`end-${i + 1}`]: "" }
            }
            // update props with null
            let propsStart = {}
            let propsEnd = {}
            propsStart = { [1]:  null}
            propsEnd = { [`end-${1}`]: null }
            props.updateDailyShift(propsStart,propsEnd)

            setStartTime(tempStart);
            setEndTime(tempEnd); 
            

            
            
        }
    },[props.flag]); 


    useEffect(() => {
        let tempStart = {}
    let tempEnd = {}
    let length = props.eventHours.length || 1
    for (let i =0; i< length;i++){
       tempStart = { ...tempStart, [i + 1]: props.eventHours.length > 0 ? props.eventHours[i].value1 : null}
       tempEnd = { ...tempEnd, [`end-${i + 1}`]: props.eventHours.length > 0 ? props.eventHours[i].value2 : null }
    }
    props.updateDailyShift(tempStart,tempEnd)
        setStartTime(tempStart)
        setEndTime(tempEnd); 
        
        updateRowCount(length)
        
    },[props.cancelFlag]); 

    

   
    

     const add = () => {
        console.log(eventHoursList  + "we have an array")
        if (eventHoursList!= undefined) {  
            let tempStart = {}
            let tempEnd = {}
            tempStart = { ...startTime, [rowCount + 1]: null }
            tempEnd = { ...endTime, [`end-${rowCount + 1}`]: null }
            props.updateDailyShift(tempStart,tempEnd)
            setStartTime(startTime => ({ ...startTime, [rowCount + 1]: "" }));
            setEndTime(endTime => ({ ...endTime, [`end-${rowCount + 1}`]: "" }))
    
            updateRowCount(rowCount + 1)
            setHaveAdded(false)
            setEventHoursList(eventHoursList)
        }
        console.log("Event Hours LIST" ,(eventHoursList)) 
    }

    const remove = () => {
        console.log("remove start",startTime);
        console.log("remove end",endTime);
        if (eventHoursList!= undefined) {
            updateRowCount(rowCount - 1)
            setHaveRemoved(false)
            eventHoursList.pop()
            setEventHoursList(eventHoursList)
            delete(startTime[rowCount]);
            delete(endTime[`end-${rowCount}`]);
            props.updateDailyShift(startTime,endTime)
        }
        console.log("after remove start",startTime);
        console.log("after remove end",endTime);
        
        console.log("Event LIST" + JSON.stringify(eventHoursList)) 
    }

    const makeEditable = () => {
        console.log(readOnlyView + " ready only ")
        if (readOnlyView == true) {
            setReadyOnly(false)
        } 
    }
    const makeReadOnly = () => {
        if (readOnlyView == false) {
            setReadyOnly(true)
        } 
    }
    const handleStartTimeChange = e => {
        console.log("start time",e.target.value)
        let startTimeTemp = {}
        startTimeTemp = {...startTime, [e.target.name]: e.target.value}
       // console.log("changinh",startTimeTemp)
        setStartTime(startTime => ({ ...startTime, [e.target.name]: e.target.value }));
        props.updateDailyShift(startTimeTemp,endTime)
       // console.log("start time", startTime)
    }
        
        
    
    const handleEndTimeChange = e => {
        console.log("end time",e.target.value)
        let endTimeTemp = {}
        endTimeTemp = {...endTime, [e.target.name]: e.target.value}
        setEndTime(endTime => ({ ...endTime, [e.target.name]: e.target.value }));
        props.updateDailyShift(startTime,endTimeTemp)
       // console.log("endTime", endTime)
    }

   


    const ShowIcons = (showAdd,showDel,rowCount) => {
        console.log("readOnlyView " + readOnlyView)
        if(showAdd && showDel && (rowCount > 1)) {
            return (
                <div> 
                <div className = {eventClasses.addicon}> <IconButton disabled={props.readOnlyView}><Icon  onClick={add} fontSize="small" name='plus'/></IconButton>  </div>
                <div className = {eventClasses.addicon}> <IconButton disabled={props.readOnlyView}><DeleteOutlinedIcon  onClick={remove} fontSize="small" name='delete'/></IconButton>  </div>
            </div>
            )
        } else if (showAdd && rowCount == 1) {
            return (
            <div> 
                <div className = {eventClasses.addicon}> <IconButton disabled={props.readOnlyView}> <Icon onClick={add} fontSize="small" name='plus'/></IconButton>   </div>
            </div>
            )
            
        } else if (showDel) {
            return(
                <div> 
               <div className = {eventClasses.addicon}> <IconButton disabled={props.readOnlyView}><DeleteOutlinedIcon onClick={remove} fontSize="small" name='delete'/></IconButton>   </div>
            </div>
            )
            
        } else {
            <div> 
            </div>
        }
    }
    const AddRow = (showName,showAdd,showDelete,index) => {
        let indx = index.toString()
        console.log(index + 1  + " row Count")
        let temp = index + 1
         return (
           <React.Fragment>
              <Grid container spacing={4}  rowSpacing={2}>
              <Grid item xs={.5}></Grid>
             <Grid item xs={2} >
             {showName ? (<div className="eventDetails"> Daily&nbsp;Shift&nbsp;Hours </div>)
             : <div></div>}
             </Grid>
             <Grid item xs={12}></Grid>
             
             <Grid item xs={3}>
             
             {(index<9)?<TextField id = {indx}  inputProps={{ readOnly: true }}  sx={{ minWidth:"100%",left:"6%" }} label="Range" defaultValue={"0" + temp}/>
             :<TextField id = {indx}  inputProps={{ readOnly: true }}  sx={{ minWidth:"100%",left:"6%" }} label="Range" defaultValue={temp}/>}
             
             </Grid>
             <Grid item xs={3}>
             
             <TextField   
             id = {indx} 
             name={index + 1}  
             inputProps={{readOnly: props.readOnlyView}}
             sx={{ minWidth:"100%",left:"6%" }} 
             label="Start Value"  
             value = {startTime[index + 1] || (props.readOnlyView) && (props.eventHours[index] && props.eventHours[index].value1) || "" }  
             onChange = {handleStartTimeChange} />
             
             </Grid>
             <Grid item xs={3}>
                <FormControl  style={{minWidth: '100%'}}>
                <TextField  
                id = {indx} 
                name={`end-${index + 1}`}  
                inputProps={{ readOnly: props.readOnlyView }}  
                sx={{ minWidth:"100%",left:"6%" }} 
                label="End Value"  
                value = {endTime[`end-${index + 1}`] || (props.readOnlyView) && (props.eventHours[index] && props.eventHours[index].value2) || "" }  
                onChange = {handleEndTimeChange} />
                </FormControl>
            </Grid>
                
             <Grid  item xs={2}>
             {( (index > 0) && (index == rowCount-1 )  || (rowCount == 1 )) ? ShowIcons(showAdd,showDelete,rowCount):<div></div>}
             
             </Grid>
             <Grid  item xs={2} >
             </Grid>
             <Grid item xs={12} ></Grid>                
             </Grid>
           </React.Fragment>
         );
       }
       const showEventHours = () => {
        let eventHoursList = [];

        for (let i = 0; i < rowCount; i ++){
            if (i == 0) {
                eventHoursList.push(AddRow(true,true,true,i));
            } else {
                eventHoursList.push(AddRow(false,true,true,i));
            }
            
        }

       

        return (
           
            <div>
                
                <div className={eventClasses.eventpagemargin}>
                <Grid container spacing={4}  rowSpacing={4} columnSpacing={4}>
                
                
                {eventHoursList}
               
                    <Grid  item xs={2} >
                    </Grid>
                    <Grid item xs={2} >
                
                    
                    </Grid>
                    
                </Grid>
                </div>
            </div>
    )

       }//showEventHours

       return(
        showEventHours()
       ) 
      
}


export default DailyShiftHours;